import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "video-js__wrapper" }
const _hoisted_2 = {
  ref: "videoPlayer",
  class: "video-js",
  playsinline: "",
  autoplay: "",
  muted: "",
  loop: ""
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.loaded)
      ? (_openBlock(), _createBlock(_component_v_progress_circular, {
          key: 0,
          indeterminate: "",
          class: "video-js__loader",
          color: "white"
        }))
      : _createCommentVNode("", true),
    _createElementVNode("video", _hoisted_2, null, 512)
  ]))
}